import "./widgetLg.css";
import React, { Fragment, useState, useEffect } from 'react';
import axios from 'axios';
import Slider, { SliderTooltip } from 'rc-slider';
import Button1 from "../button/Button1";
import Button from 'react-bootstrap/Button'
import '../button/button1.css'

import 'rc-slider/assets/index.css';
import 'rc-tooltip/assets/bootstrap.css';
import DropdownList from "react-widgets/DropdownList";

import DropdownList1 from "../dropdownlist/Dropdownlist1";
import DropdownList2 from "../dropdownlist/Dropdownlist2";
import DropdownList3 from "../dropdownlist/Dropdownlist3";
import '../../Images/Graph_PNG.css'

import CircularProgress from '@mui/material/CircularProgress';
import DiscreteSliderMarks from "../slider/MuiSlider";
import DiscreteSliderMarks2 from "../slider/MuiSlider2";
import DiscreteSliderMarks3 from "../slider/MuiSlider3";
import DiscreteSliderMarks4 from "../slider/MuiSlider4";
import DiscreteSliderMarks5 from "../slider/MuiSlider5";
import '../checkbox/Checkbox.css'
import CheckboxLabels from "../checkbox/MuiCheckbox";
import CompareWidget from "../compareWidget/CompareWidget";

import InfoIcon from '@mui/icons-material/Info';
import DownloadButton from "../button/Download";
import Tooltip from '@mui/material/Tooltip';


//const { createSliderWithTooltip } = Slider;
//const Range = createSliderWithTooltip(Slider.Range);
//const { Handle } = Slider;


const wrapperStyle = { width: 400, margin: 50 };
const wrapperStyle2 = { width: 350, marginLeft: 130, marginTop: -50};
const wrapperStyle3 = { width: 400, marginTop: 35, marginBottom: 25, marginLeft: 0, marginRight:50 };
const wrapperStyle4 = { width: 400, marginTop: 0, marginBottom: 0, marginLeft: 50, marginRight:50 };
const wrapperStyle5 = { width: 400, height: 100, marginTop: 0, marginBottom: 0, marginLeft: 50, marginRight:50 };

const infoWrapper = {marginTop: 100};
export default function WidgetLg() {

    function handleDatasetVal(dataset){
        switch(dataset) {
        case 'Acoustic Envelope':
            return(0);
        case 'Expectation Vector':
            return(1);
        case 'Word Vectors':
            return(1);
        default:
            return(1)
        }
    }

    function handleStimulusFeatureList(dataVal){
      switch(dataVal) {
      case 'music':
          return(['Acoustic Envelope','Expectation Vector']);
      case 'speech':
        return(['Acoustic Envelope',  'Word Vectors']);
      default:
          return(['Acoustic Envelope', 'Word Vectors']);
      }
  }
    
    {/* Dataset Declarations*/}
    const datasets = ["speech", "music"]
    const [datasetValue, setDatasetValue] = useState(datasets)
    const [initialDatasetValue, setInitialDatasetValue] = useState('speech')
    const [stimulusFeatures, setStimulusFeatures] = useState(handleStimulusFeatureList('speech'))
    const [initialStimulusFeaturesValue, setInitialStimulusFeaturesValue] = useState('Acoustic Envelope')

    {/* Slider Declarations*/}
    const [dd1Value, dd1SetValue] = useState(initialDatasetValue)
    const [stimValue, dd2SetValue] = useState('Acoustic Envelope') 
    const [plotValue, dd3SetValue] = useState('trf')
    const [lagSliderValue, setLagSliderValue] = useState([-0.4, 0.6])
    const [lambdaSliderValue, setLambdaSliderValue] = useState([0,1000])
    const [subjectsSliderValue, setSubjectsSliderValue] = useState(1)
    const [trialSliderValue, setTrialSliderValue] = useState(5)
    const [checkboxState, setCheckboxState] = useState(false) 
    
    {/* Image Declarations*/}
    const [image1, setImage1] = useState(false)
    const [image2, setImage2] = useState(false)

    {/* Variable Declarations*/}
    const [stimFeatureVar, setStimFeatureVar] = useState(handleDatasetVal(stimValue))
    const [loading, setLoading] = useState(false)
    const [currentSub, setCurrentSub] = useState(1)
    const [datasetVar, setDatasetVar] = useState('speech')
    const [graphVar, setGraphVar] = useState('trf')
    const [lambdaVar, setLambdaVar] = useState([0,1000])
    const [lagVar, setLagVar] = useState([-0.4, 0.6])
    const [subjectsVar, setSubjectsVar] = useState(1)
    const [trialsVar, setTrialsVar] = useState(5)
    const [plotImages, setPlotImages] = useState([])
    const [images, setImages] = useState([])
    const [directionValue, setDirection] = useState(1)
    const [trf, setTrf] = useState([])
    const [upsample, setUpsample] = useState(false)
    

    {/* Server declarations*/}
    const apiUrl = process.env.REACT_APP_URL;


    
    const [message, setMessage] = useState('');
    const [imageUrl, setImageUrl] = useState('');

  async function handleGenerateImage() {
    setImage1(false);
    setImage2(false);
    setPlotImages([]);
    setLoading(true);
    setCurrentSub(1);
    try {
        const imageParams = {
          dataset_var: dd1Value, 
          chart_var: plotValue, 
          lambda_var1: lambdaSliderValue[0], 
          lambda_var2: lambdaSliderValue[1], 
          lag_var1: lagSliderValue[0], 
          lag_var2: lagSliderValue[1], 
          stim_var: handleDatasetVal(stimValue), 
          nsubjects_var: subjectsSliderValue, 
          ntrials_var: trialSliderValue, 
          direction: directionValue,
          upsample: upsample,
        }

      const response = await axios.post(apiUrl+'/generate_image', {
         image_params: imageParams
      });
      setMessage(response.data.message);
      setImageUrl('');
      checkImageStatus(response.data.image_id);
    } catch (error) {
      setLoading(false);
      setMessage('Failed to start image generation. Please try again.');
    }
  }

  async function handleDownload() {
    setTrf([])
    try {
        const trfParams = {
          dataset_var: dd1Value, 
          chart_var: plotValue, 
          lambda_var1: lambdaSliderValue[0], 
          lambda_var2: lambdaSliderValue[1], 
          lag_var1: lagSliderValue[0], 
          lag_var2: lagSliderValue[1], 
          stim_var: handleDatasetVal(stimValue), 
          nsubjects_var: subjectsSliderValue, 
          ntrials_var: trialSliderValue, 
          type: datasetVar,
          direction: directionValue,
          upsample: upsample,
        }

      const response = await axios.post(apiUrl+'/download', {
         data_params: trfParams
      });
      setTrf(response.trf);
      downloadArray();
    } catch (error) {
      setMessage('Failed to start image generation. Please try again.');
    }
  }

  const downloadArray = () => {
    const blob = new Blob([JSON.stringify(trf)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'trf.json';
    link.click();
  };


  const handleCheckboxChange = () => {
    setUpsample(!upsample);
  };







  const checkImageStatus = async (imageId) => {
    try {
      const response = await axios.post(apiUrl+'/check_image_status', {
        image_id: imageId
      });
      if (response.data.status === 'ready') {
        setPlotImages(response.data.urls);
        setImage1(plotImages[0]); 
        setImage2(plotImages[1]); 
        setCurrentSub(currentSub+1)
        setLoading(false);
        //setTimeout(() => checkImageStatus(imageId), 5000); // check for the other images
      } else if (response.data.status === 'processing') {
        setMessage('Image is still processing. Please wait...');
        // Call this function again after a delay to check again
        setTimeout(() => checkImageStatus(imageId), 5000); // Check every 5 seconds (adjust as needed)
      }
      // else if (response.data.status === 'finished') {
      //  setPlotImages(response.data.urls);
      //  setImage1(plotImages[0]); 
      //  setImage2(plotImages[1]);    
            
     // } 
      else {
        setLoading(false);
        setMessage('Image generation failed. Please try again.');
      }
    } catch (error) {
      setLoading(false);
      setMessage('Error checking image status. Please try again later.');
    }
  };

    
  return (
    
    <div className="widgetLg">

      {/* DropDown List 1 */}
      <h1 style={wrapperStyle4}>Encoding</h1>
      <div style={wrapperStyle}>
      <h3 className="widgetLgTitle">Dataset<Tooltip title="The dataset to run the experiment on.">
        <InfoIcon color='primary'> </InfoIcon>
        </Tooltip></h3>

      {/* Dataset Dropdown */}
      <DropdownList defaultValue={initialDatasetValue} data={datasets}
      value={dd1Value}
      onChange={dd1Value => { dd1SetValue(dd1Value); 
        setStimulusFeatures(handleStimulusFeatureList(dd1Value));}}/>
    
      </div>



    <div>
    {/*<DiscreteSliderMarks4 setSubjectsSliderValue={setSubjectsSliderValue}  markers={"marksTrialLength"} sliderTitle={"Length of Each Trial"} minAmount={100} stepAmount={100} marksAmount={500} defaultValue={100} /> */}
    <DiscreteSliderMarks5 setTrialSliderValue={setTrialSliderValue} sliderTitle={"Number of Trials"} />
    <DiscreteSliderMarks3 setSubjectsSliderValue={setSubjectsSliderValue}  sliderTitle={"Number of Subjects"} />
    <DiscreteSliderMarks setLagSliderValue={setLagSliderValue}  sliderTitle={"Lags"}/>
    <DiscreteSliderMarks2 setLambdaSliderValue={setLambdaSliderValue}  sliderTitle={"Lambda"}/>    
    </div>

    
    {/* DropDown List 2 */}
    <div style={wrapperStyle}>
      <h3 className="widgetLgTitle">Stimulus Feature <Tooltip title="The stimulus feature to run the experiment on.">
        <InfoIcon color='primary' > </InfoIcon>
    </Tooltip></h3>

      <DropdownList defaultValue={initialStimulusFeaturesValue} data={stimulusFeatures}
      value={stimValue}
      onChange={stimValue => {dd2SetValue(stimValue);}}/>

    </div>


    <div style = {wrapperStyle}> 
    
    <label >
    Upsample <Tooltip title="Check to upsample to 64Hz.">
        <InfoIcon color='primary' > </InfoIcon>
    </Tooltip>
        <input
          type="checkbox"
          checked={upsample}
          onChange={handleCheckboxChange}
        />

      </label>
    </div>


    
    {loading ? <div style={wrapperStyle}>      
    <Button className={"buttonD"} onClick={() => {}}>Loading...</Button>{' '}
    <p> Loading.... Expected to take {30 + subjectsSliderValue*10} seconds....</p>
    </div>
    :
    
    <div style={wrapperStyle}>
        {/* SECOND BEGINS */}
    <Button className={"button1"} onClick={() => {setImage1(false); setImage2(false); handleGenerateImage(); setLoading(true)}} >Confirm</Button>{' '}
    {image1 ?   (<Button className={"button1"}  onClick={() => { handleDownload()}} >Download TRF data</Button>): (<Fragment></Fragment> )}
    
    </div> 
    }
 
    
    
    {/* Circular Progress Bar when loading each image*/}

    {loading ?   <div className='image1'><CircularProgress className="spinner1"></CircularProgress> <Tooltip title="TRF plot.">
        <InfoIcon color='primary' > </InfoIcon>
</Tooltip> </div>: <div className='image1'><p className='text1'>Click "Confirm" to Output Graph</p> <Tooltip title="TRF plot..">
        <InfoIcon color='primary' > </InfoIcon>
</Tooltip></div>}
    {loading ?   <div className='image2'><CircularProgress className="spinner2"></CircularProgress> <Tooltip title="Cross Validation Accuracy for each selected Lambda.">
        <InfoIcon color='primary' > </InfoIcon>
</Tooltip> </div>: <div className='image2'><p className='text2'>Click "Confirm" to Output Graph</p> <Tooltip title="Cross Validation Accuracy for each selected Lambda.">
        <InfoIcon color='primary' > </InfoIcon>
</Tooltip></div>}

    {/* Image Sources to load once matlab generates image*/}
    <div>
     {image1 ? ( <img src={plotImages[0]} alt="Plot" className="image1" />) : (<Fragment></Fragment> )}
    {image2 ?  ( <img src={plotImages[1]} alt="Plot" className="image2" />) : (<Fragment></Fragment> )}
    
      
    
     <Fragment/>
    </div>
  
      {plotImages.map((imageData, index) => (
        <img
          key={index}
          src={`data:image/jpg;base64,${imageData}`}
          alt={`Plot ${index + 1}`}
          className={`image${index + 1}`}
            />
          ))}
    </div>
    

);}